

 import iconSuccess from '../images/alert/ic_alert_email_success.svg'
 import iconFail from '../images/alert/ic_alert_email_error.svg'

const ModalAlertError = (props) => {

  let confirmClick = props.confirmClick
  let isSuccess = props.isSuccess
  let title = props.title
  let message = props.message

  function confirmOnClick () {
    confirmClick()
  }

  return (
    <div className={'  fixed z-[9999] inset-0 overflow-y-auto  '}  aria-labelledby="modal-title" role="dialog" aria-modal="true">
      <div className="flex  items-center md:items-end justify-center h-full md:h-fit  lg:max-h-screen pt-4 px-4 md:px-12 lg:px-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 bg-black backdrop-blur-[10px] bg-opacity-[0.48] transition-opacity" aria-hidden="true"></div>

        <span className="hidden sm:inline-block align-middle h-screen" aria-hidden="true">&#8203;</span>
    
        <div className=" w-full  lg:w-[400px] inline-block bg-white rounded-xl   overflow-hidden shadow-box transform transition-all  align-middle">
          
          <div className='w-full  flex-wrap lg:flex-nowrap pt-[24px] px-[24px]'>
            <div className='w-full '>

              <img 
                alt='ic_alert_success' 
                src={  iconFail } 
                width={48}
                height={48}
              />
            </div>
          </div>

   
            {
              <div className=' w-full flex flex-wrap mt-[16px] px-[24px] pb-[24px]'>
                <span className='flex w-full justify-start text-black text-[18px] font-medium text-left '>{ title }</span>
                { 
                  message ?
                  <span className='flex w-full mt-[16px] text-grey-600 text-[16px] font-normal  text-left '>{ message }</span>    
                  :
                  null

                }
              </div>         
            }
              
          <div className='w-full flex flex-wrap pb-[24px] bg-Secondary px-6 justify-end'>
            <div className='w-full lg:w-fit lg:flex '>
              <button 
                  onClick={confirmOnClick}
                  className={'w-full text-base leading-6 h-[48px] px-[16px] py-[8px]  font-medium rounded-lg border-radius-other  '+ ( (false)? ' bg-grey-600 text-white ' : ' bg-green-500 text-white ')}>
                    ตกลง
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>   
  )
}

export default ModalAlertError